/*
    Pomocný skript, který upraví patičku, aby byla přes celou šířku wrapperu kvůli nekonzistenci v designu
    (napříč Blesk, BPŽ, Počasí, Horoskopy, Blesk TV | mobile / desktop)
*/

export const footer = (footerElement: HTMLElement) => {
    const wrapperElement = footerElement.parentElement;

    const gridContainer: HTMLElement | null = document.querySelector('[data-grid-container]');

    if (wrapperElement && !gridContainer) {
        const wrapperElementStyles = window.getComputedStyle(wrapperElement);
        const wrapperElementPadding = parseInt(wrapperElementStyles.paddingLeft) + parseInt(wrapperElementStyles.paddingRight);

        footerElement.style.width = `calc(100% + ${wrapperElementPadding}px)`;
        footerElement.style.marginLeft = `-${wrapperElementPadding / 2}px`;
        footerElement.style.marginRight = `-${wrapperElementPadding / 2}px`;

        // Odstranit mezeru pod patičkou
        wrapperElement.style.paddingBottom = '0';
    }
};